import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { toast } from "sonner";

function StatCard({ label, value, testid }) {
  return (
    <div className="paper-card p-6" data-testid={testid}>
      <div className="eyebrow">{label}</div>
      <div className="font-serif-elegant text-4xl md:text-5xl mt-2">{value}</div>
    </div>
  );
}

export default function AdminDashboard() {
  const { logout, user } = useAuth();
  const nav = useNavigate();
  const [stats, setStats] = useState(null);
  const [weddings, setWeddings] = useState([]);

  const load = async () => {
    try {
      const [s, w] = await Promise.all([api.get("/dashboard/stats"), api.get("/weddings")]);
      setStats(s.data);
      setWeddings(w.data);
    } catch { toast.error("Yüklenemedi"); }
  };
  useEffect(() => { load(); }, []);

  const remove = async (id) => {
    if (!window.confirm("Bu düğünü ve tüm verilerini silmek istediğinize emin misiniz?")) return;
    await api.delete(`/weddings/${id}`);
    load();
    toast.success("Silindi");
  };

  return (
    <div className="min-h-screen bg-brand">
      <header className="border-b border-brand bg-surface-brand">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-6 flex items-center justify-between">
          <div>
            <div className="eyebrow">BiGeldi Studio</div>
            <div className="font-serif-elegant text-2xl">Yönetim Paneli</div>
          </div>
          <div className="flex items-center gap-4">
            <span className="text-xs text-secondary-brand hidden md:inline">{user?.email}</span>
            <button className="btn-ghost" onClick={async ()=>{await logout(); nav("/admin/login");}} data-testid="admin-logout">Çıkış</button>
          </div>
        </div>
      </header>

      <div className="max-w-7xl mx-auto px-6 md:px-10 py-10">
        {stats && (
          <div className="grid grid-cols-2 md:grid-cols-5 gap-4 mb-10">
            <StatCard label="Toplam Düğün" value={stats.total_weddings} testid="stat-total-weddings" />
            <StatCard label="Aktif Davetiye" value={stats.active} testid="stat-active" />
            <StatCard label="Toplam LCV" value={stats.total_rsvps} testid="stat-total-rsvp" />
            <StatCard label="Katılacak" value={stats.attending} testid="stat-attending" />
            <StatCard label="Onay Bekleyen" value={stats.pending_media} testid="stat-pending-media" />
          </div>
        )}

        <div className="flex items-center justify-between mb-6">
          <h2 className="font-serif-elegant text-3xl">Düğünler</h2>
          <Link to="/admin/wedding/new" className="btn-primary" data-testid="admin-new-wedding">+ Yeni Düğün</Link>
        </div>

        <div className="paper-card overflow-hidden">
          <table className="w-full text-sm">
            <thead className="text-left text-xs uppercase tracking-luxury text-secondary-brand border-b border-brand">
              <tr>
                <th className="p-4">Çift</th>
                <th className="p-4">Tarih</th>
                <th className="p-4">URL</th>
                <th className="p-4">LCV</th>
                <th className="p-4"></th>
              </tr>
            </thead>
            <tbody>
              {weddings.map((w) => (
                <tr key={w.id} className="border-b border-brand hover:bg-brand/50" data-testid={`wedding-row-${w.slug}`}>
                  <td className="p-4 font-serif-elegant text-lg">{w.bride_name} & {w.groom_name}</td>
                  <td className="p-4 text-secondary-brand">{w.wedding_date} · {w.wedding_time}</td>
                  <td className="p-4"><Link to={`/dugun/${w.slug}`} target="_blank" className="text-accent-brand hover:underline">/dugun/{w.slug}</Link></td>
                  <td className="p-4">{w.rsvp_count || 0}</td>
                  <td className="p-4 text-right">
                    <Link to={`/admin/wedding/${w.id}`} className="btn-ghost mr-2" data-testid={`edit-${w.slug}`}>Düzenle</Link>
                    <button onClick={()=>remove(w.id)} className="btn-ghost" data-testid={`delete-${w.slug}`}>Sil</button>
                  </td>
                </tr>
              ))}
              {weddings.length === 0 && (
                <tr><td colSpan={5} className="p-10 text-center text-secondary-brand">Henüz düğün eklenmedi.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
